/**
 * Provides JS functionality for webforms.
 */
class Webforms extends DrupalBehavior {
  onReady(document) {
    if ($('.webform-wrapper').length > 0) {
      nakedFormSelect('.webform-wrapper select');
    }
  }

}

DrupalBehavior.register('camc.components', 'webforms', Webforms);
